import React, { useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'; 
import VehicleModel from "./models/VehicleModel";
import VehicleModal from "./VehicleModal";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";
import { logAuditEvent } from '../../utils/auditLogger';

function VehicleGrid(props) {
  const [actionType, setActionType] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [vehicleModel, setVehicleModel] = useState(new VehicleModel());
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);
  const moduleName = props.moduleName || 'Vehicle Entry';

  function closeModal() {
    setIsOpen(false);
    props.fetchVehicles();
  }

  const rows = props.VehicleData
    ? props.VehicleData.filter(
      (item) =>
        (item.Manufacturer &&
          item.Manufacturer.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.ModelName &&
          item.ModelName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.VehicleType &&
          item.VehicleType.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    const detail = row?.Manufacturer ? `Vehicle: ${row.Manufacturer} ${row.ModelName}` : '';
    logAuditEvent(moduleName, `${name} Click`, `${name} clicked. ${detail}`.trim());
    // Set the action before opening to ensure correct modal content renders
    setActionType(name);
    setVehicleModel(row);
    setIsOpen(true);
  };

  async function onSubmit(e, data) {
    const vehicleData = data;
    const formatDate = (d) => {
      if (!d) return null;
      const dateObj = typeof d === 'string' || d instanceof String ? new Date(d) : d;
      if (isNaN(dateObj)) return null;
      return dateObj.toISOString().slice(0, 10); // YYYY-MM-DD
    };
    if (e.target.name === "Edit") {
      let vehicleDetails = {
        VehicleId: vehicleData.VehicleId,
        VehicleType: vehicleData.VehicleType,
        Manufacturer: vehicleData.Manufacturer,
        ModelName: vehicleData.ModelName,
        Variant: vehicleData.Variant,
        Segment: vehicleData.Segment,
        Color: vehicleData.Color,
        FuelType: vehicleData.FuelType,
        EngineCC: vehicleData.EngineCC,
        LaunchDate: formatDate(vehicleData.LaunchDate),
        DiscontinueDate: formatDate(vehicleData.DiscontinueDate),
        Status: vehicleData.Status,
        Remarks: vehicleData.Remarks,
        UserId: getStorageValues('userId')
      };
      if (validation(vehicleDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/vehicle/save", 
            vehicleDetails
          );
          if (response.status === 200) {
            if (response.data.data && response.data.data[0] && response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message || "Vehicle updated successfully!!", "Success", setAlert);
              logAuditEvent(moduleName, 'Vehicle Updated', `Vehicle ID: ${vehicleData.VehicleId} updated`);
              props.fetchVehicles();
              closeModal();
            } else {
              CreateAlert(response.data.data[0]?.message || "Error updating vehicle", "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
          CreateAlert("Error updating vehicle", "Error", setAlert);
        }
      }
    } else if (e.target.name === "Add") {
      let vehicleDetails = {
        VehicleType: vehicleData.VehicleType,
        Manufacturer: vehicleData.Manufacturer,
        ModelName: vehicleData.ModelName,
        Variant: vehicleData.Variant,
        Segment: vehicleData.Segment,
        Color: vehicleData.Color,
        FuelType: vehicleData.FuelType,
        EngineCC: vehicleData.EngineCC,
        LaunchDate: formatDate(vehicleData.LaunchDate),
        DiscontinueDate: formatDate(vehicleData.DiscontinueDate),
        Status: vehicleData.Status,
        Remarks: vehicleData.Remarks,
        UserId: getStorageValues('userId')
      };
      if (validation(vehicleDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/vehicle/save", 
            vehicleDetails
          );
          if (response.status === 200) {
            if (response.data.data && response.data.data[0] && response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message || "Vehicle added successfully!!", "Success", setAlert);
              logAuditEvent(moduleName, 'Vehicle Created', `New vehicle: ${vehicleData.Manufacturer} ${vehicleData.ModelName} created`);
              props.fetchVehicles();
              closeModal();
            } else {
              CreateAlert(response.data.data[0]?.message || "Error adding vehicle", "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
          CreateAlert("Error adding vehicle", "Error", setAlert);
        }
      }
    } else if(e.target.name === "Delete"){
      let vehicleDetails = {
        VehicleId: vehicleData.VehicleId,
        UserId: getStorageValues('userId')
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/vehicle/delete", 
          vehicleDetails
        );
        if (response.status === 200) {
          CreateAlert("Vehicle deleted successfully!!", "Success", setAlert);
          logAuditEvent(moduleName, 'Vehicle Deleted', `Vehicle ID: ${vehicleData.VehicleId} deleted`);
          props.fetchVehicles();
          closeModal();
        }
      } catch (error) {
        console.log(error);
        CreateAlert("Error deleting vehicle", "Error", setAlert);
      }
    }
  };

  function validation(vehicleDetails) {
    var validation = true;
    if (vehicleDetails) {
      if (!vehicleDetails.VehicleType || vehicleDetails.VehicleType.length === 0) {
        CreateAlert("Please select vehicle type!!", "Warning", setAlert);
        validation = false;
      } else if (!vehicleDetails.Manufacturer || vehicleDetails.Manufacturer.length === 0) {
        CreateAlert("Please enter manufacturer name!!", "Warning", setAlert);
        validation = false;
      } else if (!vehicleDetails.ModelName || vehicleDetails.ModelName.length === 0) {
        CreateAlert("Please enter model name!!", "Warning", setAlert);
        validation = false;
      } else if (!vehicleDetails.Variant || vehicleDetails.Variant.length === 0) {
        CreateAlert("Please select variant!!", "Warning", setAlert);
        validation = false;
      } else if (!vehicleDetails.Segment || vehicleDetails.Segment.length === 0) {
        CreateAlert("Please select segment!!", "Warning", setAlert);
        validation = false;
      } else if (!vehicleDetails.Color || vehicleDetails.Color.length === 0) {
        CreateAlert("Please enter color!!", "Warning", setAlert);
        validation = false;
      } else if (!vehicleDetails.FuelType || vehicleDetails.FuelType.length === 0) {
        CreateAlert("Please select fuel type!!", "Warning", setAlert);
        validation = false;
      } else if (!vehicleDetails.EngineCC || vehicleDetails.EngineCC.length === 0) {
        CreateAlert("Please select engine CC!!", "Warning", setAlert);
        validation = false;
      } else if (!vehicleDetails.Status || vehicleDetails.Status.length === 0) {
        CreateAlert("Please select status!!", "Warning", setAlert);
        validation = false;
      }
    } else {
      CreateAlert("Some problem fetching vehicle details entered by the user!!", "Error", setAlert);
      return (validation = false);
    }
    return validation;
  }

  const columns = [
    {
      name:<div className="titlename"><span>Manufacturer </span></div> ,
      selector: row => row.Manufacturer,
      cell: (row) => (
        <span title={row.Manufacturer}>{row.Manufacturer}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Model Name </span></div>,
      selector: row => row.ModelName,
      cell: (row) => (
        <span title={row.ModelName}>{row.ModelName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Vehicle Type </span></div>,
      selector: row => row.VehicleType,
      cell: (row) => (
        <span title={row.VehicleType}>{row.VehicleType}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Variant </span></div>,
      selector: row => row.Variant,
      cell: (row) => (
        <span title={row.Variant}>{row.Variant}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Fuel Type </span></div>,
      selector: row => row.FuelType,
      cell: (row) => (
        <span title={row.FuelType}>{row.FuelType}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Status </span></div>,
      selector: row => row.Status,
      cell: (row) => (
        <span title={row.Status}>{row.Status}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
  ];
  if(props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1){
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {
            props.UserPermissions.ViewModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "View");
                }}
              >
                <Icons.Eye data-feather="eye" className="action-eye" />
              </Link>
            : null
          }
          {
            props.UserPermissions.EditModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Edit");
                }}
              >
                <Icons.Edit data-feather="edit" className="feather-edit" />
              </Link>
            : null
          }
          {
            props.UserPermissions.DeleteModule === 1 ? 
              <Link
                className="confirm-text p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Delete");
                }}
              >
                <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
              </Link>
            : null
          }
        </div>
      ),
      center: "true",
      width: "150px"
    },);
  }
  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="Manufacturer"
            sortIcon={<SortArrow/>}
            persistTableHead={true}
          />
        </div>
      </div>
      <VehicleModal
        onClose={closeModal}
        onSubmit={onSubmit}
        UserAction={actionType}
        show={modalIsOpen}
        selectedRow={vehicleModel}
        moduleName={moduleName}
      />
    </>
  );
}

export default VehicleGrid;
